export const paymentHistoryHeaders = [
  {
    text: "Date Paid",
    value: "date_paid"
  },
  {
    text: "Amount",
    value: "amount"
  },
  {
    text: "Payment Method",
    value: "description"
  },
  {
    text: "Receipt",
    value: "receipt"
  }
];
